import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
//import Loading from ".././../Components/Loader/Loader";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
import DownloadSapTemplate from '../SapUploadInventory/Template/DownloadSapTemplate.xlsx';
import DateFnsUtils from "@date-io/date-fns";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { useSelector, useDispatch } from "react-redux";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
//import Checkbox from '@mui/material/Checkbox';
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";
import * as XLSX from "xlsx";

const api_master = axios.create({
    baseURL: 'InventoryMasterDetails'
})


const api_SapUpload = axios.create({
    baseURL: 'PhyInvSAPUpload'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})
export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
    {
        id: "12345678",
        firstName: "0001-HFHJS",
        lastName: "16.5",
        emailId: "sriyanka",
        phone: "9/01/2023  10:12:23",

    }
];
export const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    //backgroundColor: "var(--landing-page-card-bg-color)",
    //color: "var(--dark-blue)",
};
export const tableOptionsUser = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 3,
    // search: true,
    // add: true,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    //paging: false,
    maxBodyHeight: "600px",
};

export default function SapUpload(props) {
    //const classes = useStyles();

    const [selectedRows, setSelectedRows] = useState([]);
    //for progress
    var columns = [
        { title: " Slip Number", field: "auditSlipNumber" },
        { title: "Plant Name", field: "plantName" },
        { title: "Location", field: "locationName" },
        { title: "Material Name", field: "material" },
        { title: "Material Description", field: "materialDescription" },
        { title: " ABC Classification", field: "abcclassiification" },
        { title: "Unit Of Measure", field: "unitOfMeasurement" },
        { title: "Counted Physical Quantity", field: "countedPhyQuantity" },
        { title: "Remarks", field: "auditedQuantity" },
        { title: "Slip Created By", field: "mismatchQuantity" },
        { title: "Slip Modified By", field: "remarks" },
        { title: "Slip Creation Timestamp", field: "auditeddBy" },
        { title: "Slip Modification Timestamp", field: "createdDate" },

    ];
    var columns1 = [
        //{ title: " Select", field: "" },

        { title: "Workflow", field: "workflow" },
        { title: "Start Date", field: "workflowStartDate" },
        { title: "End Date", field: "workflowEndDate" },
        { title: "Plant Name", field: "plantName" },
        { title: "File Name", field: "fileName" },
        { title: "Created By", field: "createdBy" },
        { title: "Status", field: "status" },
        
    ];

    const [openLoader, setopenLoader] = useState(false);

    //File and user Id
    const [fileValue, setfileValue] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [inputFileValue, setInputFileValue] = useState(Date.now);
    const [UserId, seUserId] = useState(props.loginuser.response.employeeId);

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");
    const [alertwarningclass, setalertwarningclass] = useState("bg-amber clr-white");
    const [alertwarning, setalertwarning] = useState("Warning");

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');

    //Autocomplete
    const [employeeObj, setEmployeeObj] = useState('');
    const [employeeText, setEmployeeText] = useState('');

    //start date and end date

    const [toPeriod, setToPeriod] = useState(null);
    const [fromPeriod, setFromPeriod] = useState(null);
    const [isfromPeriod, setIsfromPeriod] = useState(false);
    const [istoPeriod, setIstoPeriod] = useState(false);
    const [isUploadSucess, setIsUploadSucess] = useState(false);
    const [isLoader, setIsLoader] = useState(false);

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    let isValidate = true;
    let errorList = [];
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);


    const handleErrorClose = (e) => {
        setIserror(false);
    }


    //del data
    const [deleteWorkFlow, setDeleteWorkFlowData] = useState([]);
    

    //GetWorkFlowData from table

    const [workFlowData, setWorkFlowData] = useState([]);

    function handleCloseWarning() {
        setopenWarning(false);
    }


    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 25, 50],
        paginationPosition: "bottom",
        //paging: false,
        maxBodyHeight: '600px',
        // exportButton: true,
        // exportAllData: true
    };
    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [isDisabled, setisDisabled] = useState(true);
    const [placeValue, setPlaceValue] = useState("");
    const [plant, setPlant] = useState([]);
    const handlePlace = async (event) => {
        setPlaceValue(event.target.value);
        var PlantDetails = plant.filter((item) => item.plantId === event.target.value)
        var WorkflowDetails = workFlowData.filter((item) => item.plantName === PlantDetails[0].plantName && item.status==="Active")
        /* if (WorkflowDetails[0] != "" || WorkflowDetails[0] != undefined) {*/
        if (WorkflowDetails.length > 0) {
            setFromPeriod(WorkflowDetails[0].workflowStartDate);
            setToPeriod(WorkflowDetails[0].workflowEndDate);
            setIsfromPeriod(true);
            setIstoPeriod(true); 
        }
        else {
            setFromPeriod(null);
            setToPeriod(null);
            setIsfromPeriod(false);
            setIstoPeriod(false);
        }
       
    }
    function onChangeFromPeriod (newvalue)
    {
        setFromPeriod(new Date(newvalue).toISOString().split("T")[0]);

    }

    
    //NEW FUNCS
    function clear() {

    }
    //Plant

    function getPlant(Id) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_master.get('/getTblMstPlant/'+Id,{
            headers: headers,
        })
            .then(res => {
                setPlant(res.data);
                setopenLoader(false);

            })
            .catch(error => {
                console.log("Error in hitting api at page load. MRP Controller");
                setopenLoader(false);

            })
    }

    useEffect(() => {
        getPlant(props.loginuser.response.gid);
        getWorkFlowDetails();

    }, []);
    function filePathset_Value(e) {
        let errorList = [];
        e.stopPropagation();
        e.preventDefault();
        var valuetemplatefile = e.target.files[0];
        var elementSAP = document.getElementById("SAPUploadFile");
        var element1SAP = elementSAP.parentElement.parentElement;
        setSelectedFile(e.target.files[0]);
        element1SAP.classList.remove("udi-error");
        if (valuetemplatefile !== undefined) {
            var extension = valuetemplatefile.name.split('.')[valuetemplatefile.name.split('.').length - 1];
            if (extension.toString().toUpperCase() === 'XLSX') {
                setfileValue(valuetemplatefile);
                setIsUploadSucess(false);
            }
            else {
                setfileValue(null);
                document.getElementById('SAPUploadFile').value = null;
                errorList.push("Upload Excel file only.");
                showMsg(errorList, true, 'error');
            }
        }
    }
    function showMsg(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    //Workflowdetails binding function
    function getWorkFlowDetails() {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_SapUpload.get("/getWorkFlowDetails/",{
            headers: headers,
        })
                .then(res => {
                    setWorkFlowData(res.data);
                    setopenLoader(false);
                })
                .catch(error => {
                    console.log("Error in hitting api : getWorkFlowDetails!!")
                    setopenLoader(false);
                })
        }
    

    function DeleteWorkFlowDetails() {
       // console.log("YourselectedRows", selectedRows);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        let selectedWorkflow = [];
        let errorList = [];
        selectedRows.length > 0 && selectedRows.forEach((item) => {
            selectedWorkflow.push(item.workflow, item.workflowStartDate, item.workflowEndDate, CreatedUserId);
        });
      //  console.log("selectedWorkflow", selectedWorkflow);
        api_SapUpload.post("/DeleteWorkFlow/", selectedWorkflow,{headers: headers})
            .then(res => {

                setDeleteWorkFlowData(res.data);
                //setSelectedRows("Selected Workflow has been deleted successfully!");
                errorList.push("Selected Workflow has been Comleted successfully!!");
                showMessage(errorList, true, 'success');
                getWorkFlowDetails();
                setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : DeleteWorkFlowDetails!!")
                setopenLoader(false);
            })
    }


    async function submitDatacall(e) {
            checkValidations();
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("UserId", UserId);
            formData.append("PlantID", placeValue);
            formData.append("WorkflowStartDate", fromPeriod);
            formData.append("WorkflowEndDate", toPeriod);
            bulkUploadSAPList(formData);
    }
    async function SubmitWorkFlowDetails(formData) {
        let response = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };

        if (isValidate) {
            setopenLoader(true);
            await api_SapUpload.post("/CreateWorkflow/", formData,{headers: headers})
                .then((result) => {
                    response = result.data;
                    if (response.result.objResult != null) {
                        if (response.result.objResult.length > 0) {
                            setopenLoader(false);
                            ExportDataToExcel(response.result.objResult);
                            errorList.push("File uploaded failed. Please check dowloaded error data file!!!!");
                            showMessage(errorList, true, 'error');
                        }
                    }
                   
                    else {
                        setopenLoader(false);
                        errorList.push("Workflow created successfully!!!");
                        showMessage(errorList, true, 'success');
                        getWorkFlowDetails();

                    }
                })
                .catch((error) => {
                    console.log("Error : ", error);
                    setopenLoader(false);
                    errorList.push("Something went wrong!");
                    showMessage(errorList, true, 'error');

                });
        }

        else {
            setopenLoader(false);

        }
        reset();
    }
    async function checkValidations() {
      
        if (placeValue == "" || placeValue === null || placeValue === undefined) {
            isValidate = false;
            errorList.push("Select Plant Name");
            showMessage(errorList, true, 'error');
        }
        if (fromPeriod == "" || fromPeriod === null || fromPeriod === undefined) {
            isValidate = false;
            errorList.push("Select Start Date");
            showMessage(errorList, true, 'error');
        }
        if (toPeriod == "" || toPeriod === null || toPeriod === undefined) {
            isValidate = false;
            errorList.push("Select End Date");
            showMessage(errorList, true, 'error');
        }
        if (fileValue == "" || fileValue === null || fileValue === undefined) {
            isValidate = false;
            errorList.push("Please select file!");
            showMessage(errorList, true, 'error');
        }
        return isValidate;
    }
   
    async function bulkUploadSAPList(formData) {
        let response = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (isValidate) {
            setopenLoader(true);
                await api_SapUpload.post("/SaveSAPUploadData/", formData,{headers: headers})
                    .then((result) => {
                        response = result.data;
                        //if (response.result.objResult != null) {
                        //    if (response.result.objResult.length > 0) {
                        //        setopenLoader(false);
                        //        ExportDataToExcel(response.result.objResult);
                        //        errorList.push("File uploaded failed. Please check downloaded error data file!!!!");
                        //        showMessage(errorList, true, 'error');
                        //        setIsUploadSucess(false);
                        //    }
                        //}
                        if (response.result.objResult == false) {
                           // console.log("priya", response.result.objResult);
                            setopenLoader(false);
                            if (response.result.responseMsg == "File cannot be blank") {
                                errorList.push("File cannot be blank");
                            }
                            else {
                                errorList.push("Cannot upload data more than 14000 records!!!");
                            }
                            showMessage(errorList, true, 'error');
                        }

                        else {
                            if (response.result.isResponse == false) {
                                setopenLoader(false);
                               /* setIsUploadSucess(true);*/
                                errorList.push(response.result.objResult[0].errorMsg);
                                showMessage(errorList, true, 'error');
                            }
                            else {
                                setopenLoader(false);
                                setIsUploadSucess(true);
                                errorList.push("File uploaded successfully!!!");
                                showMessage(errorList, true, 'success');
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Error : ", error);
                        setopenLoader(false);
                        setIsUploadSucess(false);
                        errorList.push("exception occurs");
                        showMessage(errorList, true, 'error');

                    });
        }

        else {
            setopenLoader(false);

        }
        //reset();
    }
    async function CreateWorkFlowDetails() {
        checkValidations();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("UserId", UserId);
        formData.append("PlantID", placeValue);
        formData.append("WorkflowStartDate", fromPeriod);
        formData.append("WorkflowEndDate", toPeriod);
        if (isUploadSucess) {
            SubmitWorkFlowDetails(formData);
        }
        else {
            errorList.push("Please upload the selected file!!!.");
            showMessage(errorList, true, 'error');
        }
    }
    function ExportDataToExcel(errorData) {
        const dataToDownload = errorData.map((row) => {
            return {
                rowNumber: row.rowIndex,
                material: row.material,
                materialDescription: row.materialDescription,
                materialType: row.materialType,
                valCl: row.valCl,
                bUn: row.bun,
                unitPrice: row.unitPrice,
                priceUnit: row.priceUnit,
                totalStock: row.totalStock,
                valA: row.valA,
                storageLocation: row.storageLocation,
                totalValue: row.totalValue,
                mRPController: row.mrpcontroller,
                aBCIndicator: row.abcindicator,
                errorMessage: row.errorMsg
            };
        });
        let headers = ["RowNumber", "Material", "Material Description", "MaterialType","ValCl",
            "BUn", "UnitPrice", "PriceUnit", "TotalStock", "ValA", "StorageLocation", "TotalValue",
            "MRPController","ABCIndicator","Error Message"];
        						

        //const workSheet = XLSX.utils.json_to_sheet(newData);
        let ws = XLSX.utils.book_new();
        let wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(ws, [headers]);
        XLSX.utils.sheet_add_json(ws, dataToDownload, {
            origin: "A2",
            skipHeader: true,
            cellStyles: true,
        });
        //ws["!cols"] = cellAdjustToContentsCustomer(dataToDownload);
        XLSX.utils.book_append_sheet(wb, ws, "ErrorData");
        XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(wb, "BulkUploadErrors.xlsx");
    }
    function cellAdjustToContentsCustomer(data) {
        return [
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.ifaNumber ? c.ifaNumber?.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.customerName ? c.customerName?.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) => (c.remarks ? c.remarks?.toString()?.length : 0))
                ),
            },
        ];
    }

    function reset() {
        setfileValue(null);
        document.getElementById('SAPUploadFile').value = null;
        setToPeriod(null);
        setFromPeriod(null);
        setPlaceValue("");
        setIsfromPeriod(false);
        setIstoPeriod(false);
        setIsUploadSucess(false);
    }

    function ValidatePeriod(todateParam) {        
        //var date = new Date(); // Now
        //date.setDate(date.getDate() + 30); // Set now + 30 days as the new date
        //console.log("See the date!:", date);
        if (fromPeriod != "" && fromPeriod != undefined) {
           
            var date = new Date(fromPeriod); // Now
            date.setDate(date.getDate() + 30); // Set now + 30 days as the new date
            var valDate = new Date(date).toISOString().split("T")[0];          

            if (todateParam > valDate) {
                let errorList = [];
                errorList.push("Workflow end date should not exceed 30 days!");
                showMessage(errorList, true, 'error');
                setFromPeriod(null);
                setToPeriod(null);
                return false;
            }
                     
           // console.log("todateParam", todateParam);            
           // console.log("valDate", valDate);
        }
        else {
            setToPeriod(null);
            errorList.push("Workflow start date should not be empty!");
            showMessage(errorList, true, 'error');

        }


    }
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    const [selectedFileDept, setSelectedFileDept] = useState(null);//firstfileupload
    const [drawingpdfKey, setDrawingpdf] = useState(Date.now);
    const handlefirstfileUpload = (e) => {
        setSelectedFileDept(e.target.files[0]);
       // console.log(e.target.files[0]);              
    };

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">SAP Upload</h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        item
                        xs={12}
                        className="d-flex jc-space-bt"
                    >
                        <Grid item xs={12} className="text-left ml-1">
                            <h4>Create new physical inventory workflow</h4>
                        </Grid>
                        
                        <Grid container spacing={2} xs={12}>
                            <Grid item xs={12} sm={6} md={3} >

                                <TextField className="lightInputFields  "
                                    select
                                    id=""
                                    //disabled={true}
                                    label="Plant Name"
                                    variant="filled"
                                    fullWidth
                                    name=""
                                    value={placeValue}
                                    onChange={handlePlace}
                                >
                                    {
                                        plant.map((h, i) =>
                                            (<MenuItem key={i} value={h.plantId}>{h.plantName}</MenuItem>))
                                    }

                                </TextField>

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        id="fromPeriod"
                                        className="datepicker"
                                        label="Start date"
                                        format="dd/MM/yyyy"
                                        InputProps={{ readOnly: true }}
                                        fullWidth
                                        value={fromPeriod}
                                        disabled={isfromPeriod}
                                        onChange={(newValue) => {
                                            { setFromPeriod(new Date(newValue).toISOString().split("T")[0]) }
                                            /*onChangeFromPeriod(newValue)*/
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        id="toPeriod"
                                        className="datepicker"
                                        label="End date"
                                        format="dd/MM/yyyy"
                                        InputProps={{ readOnly: true }}
                                        fullWidth
                                        value={toPeriod}
                                        disabled={istoPeriod}
                                        onChange={(newValue) => {
                                            {
                                                setToPeriod(new Date(newValue).toISOString().split("T")[0])
                                                ValidatePeriod(new Date(newValue).toISOString().split("T")[0]);
                                                }
                                        }}                                       
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                            </Grid>
                            <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                                </Grid>
                               
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="SAPUploadFile"
                                    variant="filled"
                                    className="bulk-upload"
                                    type="file"
                                    name="bulkUpload"
                                // key={inputFileValue}
                                onChange={(e) => filePathset_Value(e)}
                                    //key={drawingpdfKey}
                                    //onChange={handlefirstfileUpload}
                                    //helperText="please upload files only with .xlsx format"
                                />
                                <p className="info">Please upload the xlsx file with maximum 14000 records</p>
                            </Grid>
                            <Grid item xs={12} md={2} className="d-flex jc-center width-100">
                                <Button
                                    className="ns-btn-primary mt-1 mr-1"
                                    type="submit"
                                // disabled={selectedFile ? false : true}
                                   onClick={submitDatacall}
                                >
                                    Upload
                                </Button>
                            </Grid>

                           
                                <Grid item xs={12} md={3} >
                                    <a
                                    href={DownloadSapTemplate}
                                    download="DownloadSapTemplate.xlsx"
                                        target="_blank"
                                    >
                                        <Button className="ns-btn-primary mt-1 mr-1">
                                            Download Template
                                        </Button>
                                    </a>
                                </Grid>
                            

                            {/*<Grid*/}
                            {/*    container*/}
                            {/*    xs={12}*/}
                            {/*//   className="d-flex jc-space-bt"*/}
                            {/*>*/}
                            {/*    <Grid item xs={12} md={2}>*/}
                            {/*        <a*/}
                            {/*           // href={ViewRTC}*/}
                            {/*            onClick={(event) => (window.location.href = "/ViewRTC")}*/}
                            {/*            target="_blank"*/}
                            {/*        >*/}
                            {/*            <Button className="pt-button--primary bulk-upload-submit-btn">*/}
                            {/*                View RTC Data*/}
                            {/*            </Button>*/}
                            {/*        </a>*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                        </Grid>
                        {/*<Grid container xs={12} >*/}
                        {/*    <Grid item xs={12} md={3} >*/}
                        {/*        <a*/}
                        {/*            // href={RTC_ManualUpload}*/}
                        {/*            download="RTC_ManualUpload"*/}
                        {/*            target="_blank"*/}
                        {/*        >*/}
                        {/*            <Button>*/}
                        {/*            </Button>*/}
                        {/*        </a>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}


                        {/*<Grid item xs={12}>*/}
                        {/*    <h5>*/}
                        {/*        Inserted/Updated successfully :{" "}*/}
                        {/*        */}{/*{uploadRes.successCnt ? uploadRes.successCnt : "0"}{" "}*/}
                        {/*    </h5>*/}
                        {/*    <h5>*/}
                        {/*        Failed Records :*/}{/* {uploadRes.failedCnt ? uploadRes.failedCnt : "0"}*/}
                        {/*    </h5>*/}
                        {/*</Grid>*/}

                        {/*<div className="marginTop">*/}
                        {/*    <Grid item xs={12}>*/}
                        {/*        <MaterialTable*/}
                        {/*            title="Failed RTC List"*/}
                        {/*            columns={columns}*/}
                        {/*            //data={uploadRes.rtcFailedRecord}*/}
                        {/*            icons={tableIconsInputScreen}*/}
                        {/*            //isLoading={isLoader}*/}
                        {/*            options={{ tableOptionsUser, exportButton: { csv: true } }}*/}
                        {/*        />*/}
                        {/*    </Grid>*/}
                        {/*</div>*/}
                        


                    </Grid>
                    <Grid container xs={12} sm={6} >
                        <Grid item xs={12}  >

                            <Button className="ns-btn-primary mt-1 mr-1" onClick={CreateWorkFlowDetails} disabled={isUploadSucess==true ? false : true}>
                                Create Workflow
                            </Button>

                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        item
                        xs={12}
                        className="d-flex jc-space-bt"
                    >
                        <Grid item xs={12} className="text-left ml-1">
                            <h4>Complete active physical inventory workflow</h4>
                        </Grid>
                        <Grid item xs={12}>
                       
                            <Grid item xs={12}>
                                <MaterialTable
                                    title=""
                                    columns={columns1}
                                    data={workFlowData}
                                    icons={tableIconsInputScreen}
                                    //isLoading={isLoader}
                                    options={{ tableOptionsUser, exportButton: { csv: true }, selection: true }}
                                    
                                    onSelectionChange={(rows) =>
                                        setSelectedRows(rows)
                                    }  
                                />
                               
                            </Grid>
                        </Grid>
                        <Grid   className="sap-btn">
                            <Grid  >
                               
                                <Button className="ns-btn-custom mt-1 mr-1 " onClick={DeleteWorkFlowDetails}>
                                    Complete Selected  Workflow
                                </Button>

                            </Grid>-
                        </Grid>
                        

                    </Grid>
                    
                   
                </Grid>
                
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>

            </div>
        </ThemeProvider>
    );
}


